import React, { Component } from "react"
import Svg from "../../shared/_svgs/svg"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"

export class UspBannerInnerBlock extends Component {
  constructor(props) {
    super(props)

    this.state = {
      block: props.block,
      length: props.length,
    }
  }

  render() {
    const svg = SelectionFactoryHelper.getFromSelectionFactory(this.state.block.svgIcon)
    const col = 12 / this.state.length
    return (
      <div className={`grid-item col--12 col-sm--${col}`}>
        <div className="panel-simple__inner">
          {this.state.block.imageIcon ? <img srcSet={this.state.block.imageIcon} /> : svg !== "" ? <Svg iconName={svg} /> : ""}
          <span className="rich-text">
            <p>{this.state.block.description}</p>
          </span>
        </div>
      </div>
    )
  }
}
